module.exports = __webpack_public_path__ + "img/1.7fd44bef.png";